import { type DueTimingStatus, type InspectionTaskType, type WorkflowStatus } from "@/entities/inspection/types";

export * from "./inspection-details-tabs.constants";

// Inspection interval types
export const INTERVAL_TYPES = {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  YEARLY: "yearly",
} as const;

// Inspection task types
export const TASK_TYPES = {
  CHECKBOX: "checkbox",
  MEASUREMENT: "measurement",
  READING: "reading",
  INSPECTION: "inspection",
  REFILL_FLUID: "refill_fluid",
  SCAN_BARCODE: "scan_barcode",
} as const;

// Task types that require a target value
export const TASK_TYPES_REQUIRING_TARGET_VALUE: InspectionTaskType[] = [
  TASK_TYPES.MEASUREMENT,
  TASK_TYPES.READING,
  TASK_TYPES.REFILL_FLUID,
] as const;

// Inspection interval modes
export const INTERVAL_MODES = {
  FIXED_DATE: "fixed_date",
  RELATIVE: "relative",
  OPERATING_HOURS: "operating_hours",
} as const;

export const WorkflowStatusConstants = {
  OPEN: "open",
  COMPLETED: "completed",
  INACTIVE: "inactive",
} as const;

export const DueTimingStatusConstants = {
  SCHEDULED: "scheduled",
  UPCOMING: "upcoming",
  DUE: "due",
  OVERDUE: "overdue",
} as const;

// Inspection type
export const MAINTENANCE_TYPE = {
  MAINTENANCE: "maintenance",
  INSPECTION: "inspection",
} as const;

export const TimePeriodConstants = {
  THIS_WEEK: "this_week",
  NEXT_WEEK: "next_week",
  THIS_MONTH: "this_month",
  NEXT_MONTH: "next_month",
  THIS_YEAR: "this_year",
  NEXT_YEAR: "next_year",
  CUSTOM: "custom",
} as const;

export const DISPLAY_DUE_TIMING_STATUS_CONFIG: Record<
  DueTimingStatus,
  { colorClass: string; labelKey: string }
> = {
  [DueTimingStatusConstants.DUE]: {
    colorClass:
      "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-300 border-amber-200",
    labelKey: "pages:inspection.filters.due",
  },
  [DueTimingStatusConstants.OVERDUE]: {
    colorClass:
      "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300 border-red-200",
    labelKey: "pages:inspection.filters.overdue",
  },
  [DueTimingStatusConstants.UPCOMING]: {
    colorClass:
      "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300 border-blue-200",
    labelKey: "pages:inspection.filters.upcoming",
  },
  [DueTimingStatusConstants.SCHEDULED]: {
    colorClass:
      "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300 border-gray-200",
    labelKey: "pages:inspection.filters.scheduled",
  },
};

export const DISPLAY_WORKFLOW_STATUS_CONFIG: Record<
  WorkflowStatus,
  { colorClass: string; labelKey: string }
> = {
  [WorkflowStatusConstants.OPEN]: {
    colorClass:
      "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300 border-gray-200",
    labelKey: "pages:inspection.filters.open",
  },
  [WorkflowStatusConstants.COMPLETED]: {
    colorClass:
      "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300 border-green-200",
    labelKey: "pages:inspection.filters.completed",
  },
  [WorkflowStatusConstants.INACTIVE]: {
    colorClass:
      "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300 border-gray-200",
    labelKey: "pages:inspection.filters.inactive",
  },
};

